// extracted by mini-css-extract-plugin
export default {"navItemDefault":"Navbar_navItemDefault__I1i-p","nav":"Navbar_nav__zlX2-","navItemActive":"Navbar_navItemActive__9CdUI"};